import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Backdrop, Button, CircularProgress, Grid, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import Error from '../../../../components/error/error';
import { AllRoles } from '../../../../network/APIs/APIs';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCFCLevelsAPI, allCompaniesAPI, allEmployeeRoleTypes } from '../../../../services/Functions';
import { passwordRegex } from '../../../../utils/PortalName';
import UserIconImage from '../../../../images/user.jpg'; 


const initialValues = {
  iv_type: '1',
  iv_office_code: '',
  iv_level: '',
  iv_status: 1, //Active
  iv_full_name: '',
  iv_user_name: '',
  // iv_pin_code: '',
  iv_password: '',
  iv_confirm_password: '',
  iv_email: '',
  iv_phone_no: '',
  iv_cnic: '',
  iv_role: '',
  iv_company: '',
  iv_circle: '',
  iv_division: '',
  iv_support_center: '',
  iv_sub_division: '',
}
const UserCreateForm = () => {
  const [file, setFile] = useState("")
  const [hierarchyList, setHierarchyList] = useState([]);
  const [cfcsList, setcfcsList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subdivisionList, setsubDivisionList] = useState([]);
  const [circleCode, setCircleCode] = useState(0);
  const [level, setLevel] = useState(0)
  const [divisioncode, setDivisionCode] = useState(0);
  const [subdivisioncode, setsubDivisionCode] = useState(0);
  const [centerCscId, setcenterCscId] = useState(0);
  const [viewBackdrop, setViewBackdrop] = React.useState(false);
  const [companycode, setcompanycode] = useState(0)
  const [companyList, setCompanyList] = useState([]);
  const [error, setError] = useState('');
  const { token, code: userOfficeCode, permissions, userId, hierarchy } = useSelector((state) => state.auth)
  let userCompany = userOfficeCode.slice(0, 2);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [employeeType, setEmployeeType] = useState()
  

  const [technicalLevels, setTechnicalLevels] = useState([{
    value: 1,
    label: 'PITC'
  }, {
    value: 2,
    label: 'DISCO'
  }, {
    value: 3,
    label: 'Circle'
  }, {
    value: 4,
    label: 'Division'
  }, { 
    value: 52,
    label: 'Sub Division'
  }])

  useEffect(() => {
    if (hierarchy != 1) {
      let hierarchyArray = technicalLevels
      setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
      values.iv_company = userCompany
    }
  }, [hierarchy, userCompany])

  const navigate = useNavigate();

  useEffect(() => {
    if (userCompany) {
      var formdata = new FormData();
      // if (parseInt(userCompany) !== 11 && parseInt(userCompany) !== 12 && parseInt(userCompany) !== 13 && parseInt(userCompany) !== 15 && parseInt(userCompany) !== 26 && parseInt(userCompany) !== 37 && parseInt(userCompany) !== 38 && parseInt(userCompany) !== 48 && parseInt(userCompany) !== 59) {
      //   formdata.append("companyCode", 15);
      // } else {
        formdata.append("companyCode", parseInt(userCompany));
      // }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
          let hierarchyArray = result.message
          let sortedSdArray = hierarchyArray.sort(function (a, b) {
            var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (sdA < sdB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (sdA > sdB) {
              return 1; // nameA comes after nameB in the sorted order

            }
            return 0; // names are equal, their order doesn't matter
          });
          setHierarchyList(sortedSdArray)
          // handleChange(event.target.value);
          //values.iv_company = userCompany;
        }
        )
        .catch(error => console.log('error', error));
    }
  }, [])

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        cpList.unshift({ code: 10, name: 'PITC' })
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [token,cfpBaseUrl])

  useEffect(() => {
    const getAllEmployeeRoleTypes = async () => {
      setViewBackdrop(true)
      let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
      if (employeeRoleTypes) {
        setEmployeeType(employeeRoleTypes)
      }
      setViewBackdrop(false);
    }
    getAllEmployeeRoleTypes()
  }, [])

  const [allRoles, setAllRoles] = useState([]);

  useEffect(() => {
    const getAllRoles = async () => {
      let allroles = await AllRoles(token, permissions)
      setAllRoles(allroles)
    }
    getAllRoles()
  }, [])


  const handleChangeCompany = async (event) => {
     console.log(event.target.value,"priting this 51")
    if (event) {
     console.log(event.target.value,"priting this 51")

      handleChange(event); // update the value state with the selected value
      setcompanycode(event.target.value); // update the value state with the selected value
      values.iv_office_code = event.target.value;
      setCircleCode(0)
      setDivisionCode(0)
      setsubDivisionCode(0)

      var formdata = new FormData();
      formdata.append("companyCode", event.target.value);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
          let hierarchyArray = result.message
          let sortedSdArray = hierarchyArray.sort(function (a, b) {
            var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (sdA < sdB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (sdA > sdB) {
              return 1; // nameA comes after nameB in the sorted order

            }
            return 0; // names are equal, their order doesn't matter
          });
          setHierarchyList(sortedSdArray)
          // handleChange(event.target.value);
          values.iv_company = event.target.value;
        }
        )
        .catch(error => console.log('error', error));
    }
  };

  const handleChangecircle = (event) => {
    handleChange(event);
    setCircleCode(event.target.value); // update the value state with the selected value
    const selectedCircle = circleList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    values.iv_office_code = selectedCircle.code;
    setDivisionCode(0)
    setsubDivisionCode(0)
  };

  const handleChangedivision = (event) => {
    handleChange(event);
    setDivisionCode(event.target.value); // update the value state with the selected value
    const selecteddivion = divisionList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    values.iv_office_code = selecteddivion.code;
    setsubDivisionCode(0)
    setcenterCscId(0);
  };

  const handleChangesubdivision = (event) => {
    handleChange(event);
    values.iv_office_code = event.target.value;
    setsubDivisionCode(event.target.value); // update the value state with the selected value

  };

  const handleChangecustomercenter = (event) => {
    console.log(event , 'event')
    handleChange(event);
    console.log(values.iv_office_code , 'values.iv_office_cod')

    values.iv_office_code = event.target.value;
    setcenterCscId(event.target.value); // update the value state with the selected value
  };

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniqueCircles = []

      for (let i = 0; i < hierarchyArray.length; i++) {
        const circle = hierarchyArray[i];
        const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
        if (!existingCircle) {
          uniqueCircles.push({
            code: circle.circleCode,
            name: circle.circleName
          });
        }
      }

      let sortedCircleArray = uniqueCircles.sort(function (a, b) {
        var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (circleA < circleB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (circleA > circleB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setCircleList(sortedCircleArray)
    }
  }, [hierarchyList])

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniqueDivisions = []

      for (let i = 0; i < hierarchyArray.length; i++) {
        const division = hierarchyArray[i];
        if (division.circleCode === circleCode) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (divisionA < divisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (divisionA > divisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setDivisionList(sortedDivisionArray)
    }
  }, [circleCode])

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniquesubDivisions = []
      for (let i = 0; i < hierarchyArray.length; i++) {
        const subdivision = hierarchyArray[i];
        if (subdivision.divisionCode === divisioncode) {
          const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
          if (!existingsubDivision) {
            uniquesubDivisions.push({
              code: subdivision.subDivisionCode,
              name: subdivision.subDivisionName
            });
          }
        }
      }

      let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
        var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (subdivisionA < subdivisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (subdivisionA > subdivisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setsubDivisionList(sortedsubDivisionArray)
    }
  }, [divisioncode])

  useEffect(() => {
    const AllCFCSAPI = async () => {
      setViewBackdrop(true)
      try {
        var formdata = new FormData();
        if (userOfficeCode == 10) {
          formdata.append("companyCode", '');
        } else {
          formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
        }
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              const allcfcs = result.data
              setcfcsList(allcfcs)
            }
          })
          .catch(error => console.log('error', error));
      }
      catch (e) {
      }
      setViewBackdrop(false)
    }
    AllCFCSAPI()
  }, [companycode, circleCode, divisioncode ,level])

  // const handleLevelChange = (event) => {
  //   console.log('event', event.target.value)
  //   console.log('values', values)
  //   console.log(hierarchy, 'hierarchy')
  //   handleChange(event)
  //   if (hierarchy == 1) {
  //     values.iv_role = '';
  //     if (event.target.value === 1) {
  //       console.log('inside 1')
  //       values.iv_company = 1
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = event.target.value
  //       setcompanycode(1);
  //     }
  //     else if (event.target.value === 2) {
  //       console.log('inside 2')
  //       values.iv_company = ''
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = 0
  //       setcompanycode('');
  //     }
  //     else if (event.target.value === 3) {
  //       console.log('inside 3')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 4) {
  //       console.log('inside 4')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 51) {
  //       console.log('inside 51')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_support_center = ''
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 52) {
  //       console.log('inside 52')
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //         setcompanycode('')
  //       }
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = ''
  //     }
  //   } else {
  //     if (event.target.value === 2) {
  //       values.iv_company = userCompany
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //       setcompanycode(userCompany);
  //     }
  //     else if (event.target.value === 3) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 4) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 52) {
  //       values.iv_company = userCompany
  //       setcompanycode(userCompany)
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = userCompany
  //     }
  //   }
  // }
const handleLevelChange = (event) => {
  console.log("lsassadlsldsdlssasdj",event.target.value)
    setLevel(event.target.value)
    handleChange(event)
    values.iv_role = '';
    if (event.target.value === 1) {
      values.iv_company = 1
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = event.target.value
      console.log('I"m running for PITC')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
      setcompanycode(1);
    }
    else if (event.target.value === 2) {
      console.log("consolling2")
      // values.iv_company = ''
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = userOfficeCode.slice(0,2)
      console.log('I"m running For DISCO')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
      // setcompanycode('');
    }
    else if (event.target.value === 3) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_circle = ''
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 4) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_division = ''
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 51) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_support_center = ''
      values.iv_sub_division = 0
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }
    else if (event.target.value === 52) {
      if (values.iv_company === 1) {
        values.iv_company = ''
        setcompanycode('')
      }
      values.iv_support_center = 0
      values.iv_sub_division = ''
      values.iv_office_code = ''
      console.log('I"m running For Others')
      console.log('Company Initial Value', values.iv_company)
      console.log('Circle Initial Value', values.iv_circle)
      console.log('Division Initial Value', values.iv_division)
      console.log('SupportCenter Initial Value', values.iv_support_center)
      console.log('Subdivision Initial Value', values.iv_sub_division)
    }

  }
  const errorCloses = () => {
    setError('')
  }

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_type: Yup.mixed().required('Select user type.'),
      iv_office_code: Yup.string().optional(),
      iv_level: Yup.mixed().required('Level is required'),
      iv_status: Yup.mixed().required('Level is required'),
      iv_full_name: Yup.string().required("Fullname is required").min(2, `Name can't be less than 2 characters!`).max(50, `Name can't be more than 50 characters!`),
      iv_user_name: Yup.string()
  .required("Username is required")
  .matches(/^\S*$/, "Username must not contain spaces"),
      // iv_pin_code: Yup.number().typeError("Pincode must be in number").required("Pincode is required"),
      iv_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
      iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
      iv_email: Yup.string().email('Enter valid email!').required("Email is required"),
      iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
      iv_cnic: Yup.string().min(13, "CNIC no. can not less than 13 digits.").max(13, "CNIC no. can not greater than 13 digits.").required("CNIC No. is required").matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_role: Yup.mixed().required('Role is required'),
      iv_company: Yup.string().when('iv_level', {
        is: (value) => value > 1,
        then: Yup.string().required("Company is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.string().when('iv_level', {
        is: (value) => value > 2,
        then: Yup.string().required("Circle is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_division: Yup.string().when('iv_level', {
        is: (value) => value > 3,
        then: Yup.string().required("Division is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_support_center: Yup.string().when('iv_level', {
        is: (value) => value == 51,
        then: Yup.string().required("Customer Support Center is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_sub_division: Yup.string().when('iv_level', {
        is: (value) => value == 52,
        then: Yup.string().required("Sub division is required!"),
        otherwise: Yup.string().optional()
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      
      setViewBackdrop(true);
      var formdata = new FormData();

      formdata.append("name", values.iv_full_name);
      formdata.append("code", (values.iv_type == "1" && values.iv_level === 1) ? 10 : (companycode == "0" ? values.iv_office_code.toString().slice(0, 2) : values.iv_office_code));
      formdata.append("CNIC", values.iv_cnic);
      formdata.append("phoneNo", values.iv_phone_no);
      formdata.append("email", values.iv_email);
      formdata.append("toBeCreatedUserId", values.iv_user_name);
      formdata.append("password", values.iv_password);
      formdata.append("theme", "");
      formdata.append("is_super_admin", 0); 
      formdata.append("role_id", values.iv_role);
      formdata.append("hierarchy", values.iv_level);
      formdata.append("remember_token", 1);
      formdata.append("pin_code", "0000");
      formdata.append("status", values.iv_status);
      formdata.append("created_by", userId);
      formdata.append("updated_by", "");
      formdata.append("cscId", (centerCscId == "undefined" || centerCscId == "0") ? '' : centerCscId);
      formdata.append("statusRemarks", "");
      formdata.append("companyCode", (values.iv_type == "1" && values.iv_level === 1) ? 10 : (companycode == "0" ? values.iv_office_code.toString().slice(0, 2) : companycode));
      formdata.append("circleCode", circleCode);
      formdata.append("divisionCode", divisioncode);
      formdata.append("subDivisionCode", subdivisioncode);
      formdata.append("profilePicture", file);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/addUser", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            navigate('/user-management')
          }
          else {
            setViewBackdrop(false);
            setError(result.message)
          }
        })
        .catch(error => {
          setViewBackdrop(false);
        });
    }
  });

  useEffect(() => {
    if (values.iv_level) {
      if (values.iv_level === 1) {
        values.iv_office_code = 10
      }
    }
  }, [values.iv_level])

  useEffect(() => {
    if (values.iv_type) {
      values.iv_level = '';
      values.iv_role = '';
      values.iv_circle = '';
      values.iv_office_code = '';
      setCircleCode(0)
      values.iv_division = '';
      setDivisionCode(0)
      values.iv_sub_division = '';
      setsubDivisionCode(0)
      values.iv_support_center = '';
      setcenterCscId(0)
      if (hierarchy == 1) {
        values.iv_company = '';
        setcompanycode('');
      }
    }
  }, [values.iv_type])

  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const callCFCLevels = async () => {
      setViewBackdrop(true)
      let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
      if (cfcLevelsList) {
        if (hierarchy != 1) {
          cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
        }
        setCFCLevelList(cfcLevelsList)
      }
      setViewBackdrop(false);
    }
    callCFCLevels()
  }, [])

  return (
    <>
      <Grid container className='form-box' sx={{ marginLeft: '30px', marginRight: '30px' }}>
        <Grid item lg={12}>
          <h3 className='page-title'>
            Add New User
          </h3>
        </Grid>
        <Grid item lg={12} sx={{ margin: '15px 0px' }}>
          <Grid container sx={{ backgroundColor: 'white', borderRadius: '10px', border: '1px solid lightgrey', padding: '10px', minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
            <Grid item lg={12} sx={{ height: 'max-content' }}>
              <Grid container sx={{ padding: '20px' }}>
                <Grid item lg={1.5} sx={{ border: '2px solid #006ad1', borderRadius: '10px', padding: '10px', maxHeight: '200px' }}>
                  <img src={file ? URL.createObjectURL(file) : UserIconImage} alt='avatar' style={{ width: '100%' }} />
                  <div style={{ width: '50px', height: '50px', borderRadius: '50px', backgroundColor: '#006ad1', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid white', zIndex: 1, position: 'absolute', marginLeft: '135px', marginTop: '-35px' }}>
                    <label htmlFor='file'><DriveFolderUploadIcon sx={{ cursor: 'pointer', size: 'medium', color: 'white' }} /></label>
                  </div>
                  <input type="file" id="file" accept='image/*' onChange={(e) => setFile(e.target.files[0])} style={{ display: "none" }} />
                </Grid>
                <Grid item lg={10.5} sx={{ paddingLeft: '30px', }}>
                  <Grid container >
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Employee Type</label>
                      <Grid>
                        {
                          errors.iv_type && touched.iv_type ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_type}</p>
                          ) : null
                        }
                      </Grid>
                      <FormControl className='form-control' >
                        <RadioGroup
                          className='radio-group'
                          row
                          name="iv_type"
                          defaultValue={values.iv_type}
                          value={values.iv_type}
                          onChange={handleChange}
                        >
                          {employeeType && employeeType.map((item) => {
                            return <FormControlLabel
                              value={item.roleTypeId}
                              className='form-control-label'
                              control={<Radio />}
                              label={item.roleTypeName}
                              labelPlacement="end"
                            />
                          })}
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                     <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Status</label>
                      <Grid>
                        {
                          errors.iv_status && touched.iv_status ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
                          ) : null
                        }
                      </Grid>
                      <FormControl >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_status"
                          id="iv_status"
                          className='radio'
                          value={values.iv_status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Active' />
                          <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Inactive' />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                     <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Office Code</label>
                      <TextField type='number' maxLength='5' readOnly onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} disabled sx={{
                        backgroundColor: '#EEF1F7', width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                    </Grid>
                    {
                      values.iv_type == "1" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    } {
                      values.iv_type == "2" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    }


                    {/* <Grid item lg={3} sx={{ padding: '10px' }}></Grid> */}
                    {
                      values.iv_level > 1 ?
                        <>
                          <Grid item lg={3} sx={{ padding: '10px' }}>
                            <label>Company</label>
                            <Select
  fullWidth
  value={values.iv_company}
  disabled={parseInt(hierarchy) != 1}
  onChange={handleChangeCompany}
  sx={{ height: '45px' }}
  onBlur={handleBlur}
  name="iv_company"
  id="iv_company"
>
  <MenuItem value="">Select Company</MenuItem>
  {companyList
    .filter((item) => values.iv_level > 1 ? item.code > 1 : true)
    .map((item) => (
      <MenuItem key={item.code} value={item.code}>
        {item.name}
      </MenuItem>
    ))}
</Select>

                            <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                              {errors.iv_company && touched.iv_company ? (errors.iv_company) : null}
                            </Grid>
                          </Grid>
                        </> : null
                    }
                    {
                      values.iv_level > 2 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Circle</label>
                          <Select
                            fullWidth
                            value={values.iv_circle}
                            onChange={handleChangecircle}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_circle"
                            id="iv_circle"
                          >
                            <MenuItem>Select Circle</MenuItem>
                            {
                              circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    {
                      values.iv_level > 3 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Division</label>
                          <Select
                            fullWidth
                            value={values.iv_division}
                            onChange={handleChangedivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_division"
                            id="iv_division"
                          >
                            <MenuItem>Select Division</MenuItem>
                            {
                              divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                   
                    {
                      (values.iv_level === 52 || values.iv_level == 5) ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Sub Division</label>
                          <Select
                            fullWidth
                            value={values.iv_sub_division}
                            onChange={handleChangesubdivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_sub_division"
                            id="iv_sub_division"
                          >
                            <MenuItem>Select Sub Division</MenuItem>
                            {
                              subdivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_sub_division && touched.iv_sub_division ? (errors.iv_sub_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                     {
                      (values.iv_type == "1" && values.iv_level !== 1) ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Customer Support Center</label>
                          <Select
                            fullWidth
                            value={values.iv_support_center}
                            onChange={handleChangecustomercenter}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_support_center"
                            id="iv_support_center"
                          >
                            <MenuItem>Select CFC</MenuItem>
                            {
                              cfcsList.map((item) => {
                                if ((item.cfcLevelId == values.iv_level) && ((userOfficeCode == 10 && values.iv_level == 2) ? item.companyCode == values.iv_office_code : values.iv_level == 2 ? item.companyCode == userOfficeCode.slice(0,2) : values.iv_level == 3 ? item.circleCode == values.iv_circle : values.iv_level == 4 ? item.divisionCode == values.iv_division :  values.iv_level == 5 ? item.subDivisionCode == values.iv_sub_division : "")) {
                                  return (
                                    <MenuItem value={item.cfcId}>{item.cfcName}</MenuItem>
                                  )
                                }
                              })
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_support_center && touched.iv_support_center ? (errors.iv_support_center) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px', padding: '5px' }}>
                      <h4 style={{ color: '#006ad1' }}>
                        User Role
                      </h4>
                    </Grid>
                    <Grid item lg={12} sx={{ padding: '0px 10px' }}>
                      {
                        values.iv_level &&
                        <>
                          <Grid>
                            {
                              errors.iv_role && touched.iv_role ? (
                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_role}</p>
                              ) : null
                            }
                          </Grid>
                        </>

                      }
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={values.iv_role}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <>
                            <Grid sx={{ width: '100%' }}>
                              {/* {
                                allRoles && allRoles.map((item) => {
                                console.log(values,"values");
                                console.log(item,"item");
                                  if (values.iv_level === item.level) {
                                    return <FormControlLabel sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey', marginBottom: '10px' }} value={item.id} control={<Radio />} label={item.name} />
                                  }
                                })
                              } */}
                              {
allRoles && allRoles.map((item) => {
  console.log('item', item);
  const level = values.iv_level;
  const roleTypeId = values.iv_type;
  console.log(level, roleTypeId, 'level & roleTypeId');

  if (
    (
      level == 4 &&
      (item.level == 4 || item.level == 51 ) &&
      item.roleTypeId == roleTypeId
    ) ||
    (
      level != 4 &&
      item.level == level &&
      item.roleTypeId == roleTypeId
    )
  ) {
    return (
      <FormControlLabel
        key={item.id}
        sx={{
          padding: '0px 22.5px',
          backgroundColor: 'white',
          borderRadius: '5px',
          marginLeft: '0px',
          border: '1px solid lightgrey',
          marginBottom: '10px'
        }}
        value={item.id}
        control={<Radio />}
        label={item.name}
      />
    );
  }
    return null;
  })
}
                            </Grid>
                          </>
                        </RadioGroup>
                      </FormControl>
                       {/* <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={values.iv_role}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <>
                            <Grid sx={{ width: '100%' }}>
                              {
                                allRoles && allRoles.map((item) => {
                                  if (values.iv_level === item.level) {
                                    return <FormControlLabel sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey', marginBottom: '10px' }} value={item.id} control={<Radio />} label={item.name} />
                                  }
                                })
                              }
                            </Grid>
                          </>
                        </RadioGroup>
                      </FormControl> */}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} sx={{ height: 'max-content' }}>
              <Grid container spacing={1}>
                <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 30px', padding: '5px' }}>
                  <h4 style={{ color: '#006ad1' }}>
                    User Information
                  </h4>
                </Grid>
                <Grid item lg={12}>
                  <Grid container sx={{ padding: '0px 10px', height: '20vh' }}>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Full Name</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_full_name" value={values.iv_full_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_full_name && touched.iv_full_name ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_full_name}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Username</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_user_name" value={values.iv_user_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />

                      {
                        errors.iv_user_name && touched.iv_user_name ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_user_name}</p>
                        ) : null
                      }

                    </Grid>
                    {/* <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Pin code</label>
                      <TextField type='text' autoComplete='off' maxLength='4' onChange={handleChange} name="iv_pin_code" value={values.iv_pin_code} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_pin_code && touched.iv_pin_code ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_pin_code}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid> */}
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Email Address</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_email" value={values.iv_email} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_email && touched.iv_email ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_email}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Phone No.</label>
                      <TextField type='text' maxLength='11' autoComplete='off' onChange={handleChange} inputProps={{ maxLength: 11 }} name="iv_phone_no" value={values.iv_phone_no} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_phone_no && touched.iv_phone_no ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_phone_no}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>CNIC No.</label>
                      <TextField type='text' maxLength="13" autoComplete='off' onChange={handleChange} name="iv_cnic" inputProps={{ maxLength: 13 }} value={values.iv_cnic} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_cnic && touched.iv_cnic ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_cnic}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password</label>
                      <TextField maxLength='16' type={showPassword ? 'text' : 'password'} autoComplete='off' onChange={handleChange} name="iv_password" value={values.iv_password} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end">

                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {errors.iv_password && touched.iv_password ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>
                            Password should:
                            <ul>
                              <li>have length between 8 to 16 characters.</li>
                              <li>contain at least 1 lower case letter.</li>
                              <li>contain at least 1 upper case letter.</li>
                              <li>contain at least 1 number.</li>
                              <li>contain at least 1 special character.</li>
                            </ul>
                          </p>
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password Confirmation</label>
                      <TextField
                        maxLength="16"
                        type={showConfirmPassword ? 'text' : 'password'}
                        autoComplete="off"
                        onChange={handleChange}
                        name="iv_confirm_password"
                        value={values.iv_confirm_password}
                        onBlur={handleBlur}
                        sx={{
                          width: '100%',
                          '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleClickShowConfirmPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {errors.iv_confirm_password && touched.iv_confirm_password ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_confirm_password}
                          </p>
                        ) : null}
                      </Grid>
                    </Grid>
                     <Grid item lg={3} sx={{ padding: '0px 10px',display:'flex',justifyContent:'center',alignItems:'center' }}>
                      <Button  variant="contained" size='large' sx={{width:'100%'}} onClick={handleSubmit}>
                        Submit
                      </Button>
                    </Grid>
                    <Grid item lg={12} sx={{ margin: '0px 20px 0px 10px' }}>
                      {
                        error &&
                        <Error
                          error={error}
                          onClose={() => errorCloses()}
                          backgroundColor="#FFC0CB"
                          textColor="#bb0303"
                          iconColor="#bb0303"
                        />
                      }
                    </Grid>
                  </Grid>

                  {/* <Grid container sx={{ minHeight: '17.5vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>

                    <Grid item lg={12} sx={{ padding: '0px 10px', textAlign: 'right' }}>
                      <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
                        Submit
                      </Button>
                    </Grid>
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  )
}

export default UserCreateForm


// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import { Backdrop, Button, CircularProgress, Grid, InputAdornment, MenuItem, Select, TextField } from '@mui/material';
// import FormControl from '@mui/material/FormControl';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import IconButton from '@mui/material/IconButton';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import { useFormik } from 'formik';
// import React, { useEffect, useState } from 'react';
// import 'react-image-crop/dist/ReactCrop.css';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import * as Yup from "yup";
// import Error from '../../../../components/error/error';
// import { AllRoles } from '../../../../network/APIs/APIs';
// import { cfpBaseUrl } from '../../../../network/urls';
// import { allCFCLevelsAPI, allCompaniesAPI, allEmployeeRoleTypes } from '../../../../services/Functions';
// import { passwordRegex } from '../../../../utils/PortalName';


// const initialValues = {
//   iv_type: '1',
//   iv_office_code: '',
//   iv_level: '',
//   iv_status: 1, //Active
//   iv_full_name: '',
//   iv_user_name: '',
//   // iv_pin_code: '',
//   iv_password: '',
//   iv_confirm_password: '',
//   iv_email: '',
//   iv_phone_no: '',
//   iv_cnic: '',
//   iv_role: '',
//   iv_company: '',
//   iv_circle: '',
//   iv_division: '',
//   iv_support_center: '',
//   iv_sub_division: '',
// }
// const UserCreateForm = () => {
//   const [file, setFile] = useState("")
//   const [hierarchyList, setHierarchyList] = useState([]);
//   const [cfcsList, setcfcsList] = useState([]);
//   const [circleList, setCircleList] = useState([]);
//   const [divisionList, setDivisionList] = useState([]);
//   const [subdivisionList, setsubDivisionList] = useState([]);
//   const [circleCode, setCircleCode] = useState(0);
//   const [divisioncode, setDivisionCode] = useState(0);
//   const [subdivisioncode, setsubDivisionCode] = useState(0);
//   const [centerCscId, setcenterCscId] = useState(0);
//   const [viewBackdrop, setViewBackdrop] = React.useState(false);
//   const [companycode, setcompanycode] = useState(0)
//   const [companyList, setCompanyList] = useState([]);
//   const [error, setError] = useState('');
//   const { token, code: userOfficeCode, permissions, userId, hierarchy } = useSelector((state) => state.auth)
//   let userCompany = userOfficeCode.slice(0, 2);
//   const [cfcLevelList, setCFCLevelList] = useState([]);
//   const [employeeType, setEmployeeType] = useState()

//   const [technicalLevels, setTechnicalLevels] = useState([{
//     value: 1,
//     label: 'PITC'
//   }, {
//     value: 2,
//     label: 'DISCO'
//   }, {
//     value: 3,
//     label: 'Circle'
//   }, {
//     value: 4,
//     label: 'Division'
//   }, {
//     value: 52,
//     label: 'Sub Division'
//   }])

//   useEffect(() => {
//     if (hierarchy != 1) {
//       let hierarchyArray = technicalLevels
//       setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
//       values.iv_company = userCompany
//     }
//   }, [hierarchy, userCompany])

//   const navigate = useNavigate();

//   useEffect(() => {
//     if (userCompany) {
//       var formdata = new FormData();
//       if (parseInt(userCompany) !== 11 && parseInt(userCompany) !== 12 && parseInt(userCompany) !== 13 && parseInt(userCompany) !== 15 && parseInt(userCompany) !== 26 && parseInt(userCompany) !== 37 && parseInt(userCompany) !== 38 && parseInt(userCompany) !== 48 && parseInt(userCompany) !== 59) {
//         formdata.append("companyCode", 15);
//       } else {
//         formdata.append("companyCode", parseInt(userCompany));
//       }
//       const myHeaders = new Headers();
//       myHeaders.append("Authorization", token);;
//       var requestOptions = {
//         method: 'POST',
//         body: formdata,
//         headers: myHeaders,
//         redirect: 'follow',
//       };

//       fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
//         .then(response => response.json())
//         .then(result => {
//           let hierarchyArray = result.message
//           let sortedSdArray = hierarchyArray.sort(function (a, b) {
//             var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
//             var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
//             if (sdA < sdB) {
//               return -1; // nameA comes before nameB in the sorted order
//             }
//             if (sdA > sdB) {
//               return 1; // nameA comes after nameB in the sorted order

//             }
//             return 0; // names are equal, their order doesn't matter
//           });
//           setHierarchyList(sortedSdArray)
//           // handleChange(event.target.value);
//           //values.iv_company = userCompany;
//         }
//         )
//         .catch(error => console.log('error', error));
//     }
//   }, [])

//   useEffect(() => {
//     const callAllCompanies = async () => {
//       setViewBackdrop(true)
//       let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
//       if (companiesList) {
//         companiesList = companiesList.filter(item => item.companyCode != 1)
//         let cpList = companiesList.map(item => ({
//           code: item.companyCode,
//           name: item.companyName
//         }))
//         cpList.unshift({ code: 10, name: 'PITC' })
//         setCompanyList(cpList)
//       }
//       setViewBackdrop(false);
//     }
//     callAllCompanies()
//   }, [])

//   useEffect(() => {
//     const getAllEmployeeRoleTypes = async () => {
//       setViewBackdrop(true)
//       let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
//       if (employeeRoleTypes) {
//         setEmployeeType(employeeRoleTypes)
//       }
//       setViewBackdrop(false);
//     }
//     getAllEmployeeRoleTypes()
//   }, [])

//   const [allRoles, setAllRoles] = useState([]);

//   useEffect(() => {
//     const getAllRoles = async () => {
//       let allroles = await AllRoles(token, permissions)
//       setAllRoles(allroles)
//     }
//     getAllRoles()
//   }, [])


//   const handleChangeCompany = async (event) => {
//     if (event) {
//       handleChange(event); // update the value state with the selected value
//       setcompanycode(event.target.value); // update the value state with the selected value
//       values.iv_office_code = event.target.value;
//       setCircleCode(0)
//       setDivisionCode(0)
//       setsubDivisionCode(0)

//       var formdata = new FormData();
//       formdata.append("companyCode", event.target.value);
//       const myHeaders = new Headers();
//       myHeaders.append("Authorization", token);;
//       var requestOptions = {
//         method: 'POST',
//         body: formdata,
//         headers: myHeaders,
//         redirect: 'follow',
//       };

//       await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
//         .then(response => response.json())
//         .then(result => {
//           let hierarchyArray = result.message
//           let sortedSdArray = hierarchyArray.sort(function (a, b) {
//             var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
//             var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
//             if (sdA < sdB) {
//               return -1; // nameA comes before nameB in the sorted order
//             }
//             if (sdA > sdB) {
//               return 1; // nameA comes after nameB in the sorted order

//             }
//             return 0; // names are equal, their order doesn't matter
//           });
//           setHierarchyList(sortedSdArray)
//           // handleChange(event.target.value);
//           values.iv_company = event.target.value;
//         }
//         )
//         .catch(error => console.log('error', error));
//     }
//   };

//   const handleChangecircle = (event) => {
//     handleChange(event);
//     setCircleCode(event.target.value); // update the value state with the selected value
//     const selectedCircle = circleList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
//     values.iv_office_code = selectedCircle.code;
//     setDivisionCode(0)
//     setsubDivisionCode(0)
//   };

//   const handleChangedivision = (event) => {
//     handleChange(event);
//     setDivisionCode(event.target.value); // update the value state with the selected value
//     const selecteddivion = divisionList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
//     values.iv_office_code = selecteddivion.code;
//     setsubDivisionCode(0)
//     setcenterCscId(0);
//   };

//   const handleChangesubdivision = (event) => {
//     handleChange(event);
//     values.iv_office_code = event.target.value;
//     setsubDivisionCode(event.target.value); // update the value state with the selected value

//   };

//   const handleChangecustomercenter = (event) => {
//     handleChange(event);
//     values.iv_office_code = event.target.value;
//     setcenterCscId(event.target.value); // update the value state with the selected value
//   };

//   useEffect(() => {
//     if (hierarchyList) {
//       let hierarchyArray = hierarchyList
//       let uniqueCircles = []

//       for (let i = 0; i < hierarchyArray.length; i++) {
//         const circle = hierarchyArray[i];
//         const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
//         if (!existingCircle) {
//           uniqueCircles.push({
//             code: circle.circleCode,
//             name: circle.circleName
//           });
//         }
//       }

//       let sortedCircleArray = uniqueCircles.sort(function (a, b) {
//         var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         if (circleA < circleB) {
//           return -1; // nameA comes before nameB in the sorted order
//         }
//         if (circleA > circleB) {
//           return 1; // nameA comes after nameB in the sorted order
//         }
//         return 0; // names are equal, their order doesn't matter
//       });
//       setCircleList(sortedCircleArray)
//     }
//   }, [hierarchyList])

//   useEffect(() => {
//     if (hierarchyList) {
//       let hierarchyArray = hierarchyList
//       let uniqueDivisions = []

//       for (let i = 0; i < hierarchyArray.length; i++) {
//         const division = hierarchyArray[i];
//         if (division.circleCode === circleCode) {
//           const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
//           if (!existingDivision) {
//             uniqueDivisions.push({
//               code: division.divisionCode,
//               name: division.divisionName
//             });
//           }
//         }
//       }

//       let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
//         var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         if (divisionA < divisionB) {
//           return -1; // nameA comes before nameB in the sorted order
//         }
//         if (divisionA > divisionB) {
//           return 1; // nameA comes after nameB in the sorted order
//         }
//         return 0; // names are equal, their order doesn't matter
//       });
//       setDivisionList(sortedDivisionArray)
//     }
//   }, [circleCode])

//   useEffect(() => {
//     if (hierarchyList) {
//       let hierarchyArray = hierarchyList
//       let uniquesubDivisions = []
//       for (let i = 0; i < hierarchyArray.length; i++) {
//         const subdivision = hierarchyArray[i];
//         if (subdivision.divisionCode === divisioncode) {
//           const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
//           if (!existingsubDivision) {
//             uniquesubDivisions.push({
//               code: subdivision.subDivisionCode,
//               name: subdivision.subDivisionName
//             });
//           }
//         }
//       }

//       let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
//         var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
//         if (subdivisionA < subdivisionB) {
//           return -1; // nameA comes before nameB in the sorted order
//         }
//         if (subdivisionA > subdivisionB) {
//           return 1; // nameA comes after nameB in the sorted order
//         }
//         return 0; // names are equal, their order doesn't matter
//       });
//       setsubDivisionList(sortedsubDivisionArray)
//     }
//   }, [divisioncode])

//   useEffect(() => {
//     const AllCFCSAPI = async () => {
//       setViewBackdrop(true)
//       try {
//         var formdata = new FormData();
//         if (userOfficeCode == 10) {
//           formdata.append("companyCode", '');
//         } else {
//           formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
//         }
//         const myHeaders = new Headers();
//         myHeaders.append("Authorization", token);
//         var requestOptions = {
//           method: 'POST',
//           body: formdata,
//           headers: myHeaders,
//           redirect: 'follow',
//         };
//         await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
//           .then(response => response.json())
//           .then(result => {
//             if (result.status === '200') {
//               const allcfcs = result.data
//               setcfcsList(allcfcs)
//             }
//           })
//           .catch(error => console.log('error', error));
//       }
//       catch (e) {
//       }
//       setViewBackdrop(false)
//     }
//     AllCFCSAPI()
//   }, [companycode, circleCode, divisioncode])

//   const handleLevelChange = (event) => {
//     handleChange(event)
//     if (hierarchy == 1) {
//       values.iv_role = '';
//       if (event.target.value === 1) {
//         values.iv_company = 1
//         values.iv_circle = 0
//         values.iv_division = 0
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = event.target.value
//         setcompanycode(1);
//       }
//       else if (event.target.value === 2) {
//         values.iv_company = ''
//         values.iv_circle = 0
//         values.iv_division = 0
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = 0
//         setcompanycode('');
//       }
//       else if (event.target.value === 3) {
//         if (values.iv_company === 1) {
//           values.iv_company = ''
//           setcompanycode('')
//         }
//         values.iv_circle = ''
//         values.iv_division = 0
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = ''
//       }
//       else if (event.target.value === 4) {
//         if (values.iv_company === 1) {
//           values.iv_company = ''
//           setcompanycode('')
//         }
//         values.iv_division = ''
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = ''
//       }
//       else if (event.target.value === 51) {
//         if (values.iv_company === 1) {
//           values.iv_company = ''
//           setcompanycode('')
//         }
//         values.iv_support_center = ''
//         values.iv_sub_division = 0
//         values.iv_office_code = ''
//       }
//       else if (event.target.value === 52) {
//         if (values.iv_company === 1) {
//           values.iv_company = ''
//           setcompanycode('')
//         }
//         values.iv_support_center = 0
//         values.iv_sub_division = ''
//         values.iv_office_code = ''
//       }
//     } else {
//       if (event.target.value === 2) {
//         values.iv_company = userCompany
//         values.iv_circle = 0
//         values.iv_division = 0
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = userCompany
//         setcompanycode(userCompany);
//       }
//       else if (event.target.value === 3) {
//         values.iv_company = userCompany
//         setcompanycode(userCompany)
//         values.iv_circle = ''
//         values.iv_division = 0
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = userCompany
//       }
//       else if (event.target.value === 4) {
//         values.iv_company = userCompany
//         setcompanycode(userCompany)
//         values.iv_division = ''
//         values.iv_support_center = 0
//         values.iv_sub_division = 0
//         values.iv_office_code = userCompany
//       }
//       else if (event.target.value === 52) {
//         values.iv_company = userCompany
//         setcompanycode(userCompany)
//         values.iv_support_center = 0
//         values.iv_sub_division = ''
//         values.iv_office_code = userCompany
//       }
//     }
//   }

//   const errorCloses = () => {
//     setError('')
//   }

//   const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
//     initialValues,
//     validationSchema: Yup.object({
//       iv_type: Yup.mixed().required('Select user type.'),
//       iv_office_code: Yup.string().optional(),
//       iv_level: Yup.mixed().required('Level is required'),
//       iv_status: Yup.mixed().required('Level is required'),
//       iv_full_name: Yup.string().required("Fullname is required").min(2, `Name can't be less than 2 characters!`).max(50, `Name can't be more than 50 characters!`),
//       iv_user_name: Yup.string().required("Username is required"),
//       // iv_pin_code: Yup.number().typeError("Pincode must be in number").required("Pincode is required"),
//       iv_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
//       iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
//       iv_email: Yup.string().email('Enter valid email!').required("Email is required"),
//       iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
//       iv_cnic: Yup.string().min(13, "CNIC no. can not less than 13 digits.").max(13, "CNIC no. can not greater than 13 digits.").required("CNIC No. is required").matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
//       iv_role: Yup.mixed().required('Role is required'),
//       iv_company: Yup.string().when('iv_level', {
//         is: (value) => value > 1,
//         then: Yup.string().required("Company is required!"),
//         otherwise: Yup.string().optional()
//       }),
//       iv_circle: Yup.string().when('iv_level', {
//         is: (value) => value > 2,
//         then: Yup.string().required("Circle is required!"),
//         otherwise: Yup.string().optional()
//       }),
//       iv_division: Yup.string().when('iv_level', {
//         is: (value) => value > 3,
//         then: Yup.string().required("Division is required!"),
//         otherwise: Yup.string().optional()
//       }),
//       iv_support_center: Yup.string().when('iv_level', {
//         is: (value) => value == 51,
//         then: Yup.string().required("Customer Support Center is required!"),
//         otherwise: Yup.string().optional()
//       }),
//       iv_sub_division: Yup.string().when('iv_level', {
//         is: (value) => value == 52,
//         then: Yup.string().required("Sub division is required!"),
//         otherwise: Yup.string().optional()
//       }),
//     }),
//     onSubmit: async (values, { resetForm }) => {

//       setViewBackdrop(true);
//       var formdata = new FormData();

//       formdata.append("name", values.iv_full_name);
//       formdata.append("code", values.iv_office_code);
//       formdata.append("CNIC", values.iv_cnic);
//       formdata.append("phoneNo", values.iv_phone_no);
//       formdata.append("email", values.iv_email);
//       formdata.append("toBeCreatedUserId", values.iv_user_name);
//       formdata.append("password", values.iv_password);
//       formdata.append("theme", "");
//       formdata.append("is_super_admin", 0);
//       formdata.append("role_id", values.iv_role);
//       formdata.append("hierarchy", values.iv_level);
//       formdata.append("remember_token", 1);
//       formdata.append("pin_code", "0000");
//       formdata.append("status", values.iv_status);
//       formdata.append("created_by", userId);
//       formdata.append("updated_by", "");
//       formdata.append("cscId", (centerCscId == "undefined" || centerCscId == "0") ? '' : centerCscId);
//       formdata.append("statusRemarks", "");
//       formdata.append("companyCode", companycode);
//       formdata.append("circleCode", circleCode);
//       formdata.append("divisionCode", divisioncode);
//       formdata.append("subDivisionCode", subdivisioncode);
//       formdata.append("profilePicture", file);
//       const myHeaders = new Headers();
//       myHeaders.append("Authorization", token);;

//       var requestOptions = {
//         method: 'POST',
//         body: formdata,
//         headers: myHeaders,
//         redirect: 'follow',
//       };

//       await fetch(cfpBaseUrl + "customerFaciliationPortal/addUser", requestOptions)
//         .then(response => response.json())
//         .then(result => {
//           if (result.status === '200') {
//             navigate('/user-management')
//           }
//           else {
//             setViewBackdrop(false);
//             setError(result.message)
//           }
//         })
//         .catch(error => {
//           setViewBackdrop(false);
//         });
//     }
//   });

//   useEffect(() => {
//     if (values.iv_level) {
//       if (values.iv_level === 1) {
//         values.iv_office_code = 10
//       }
//     }
//   }, [values.iv_level])

//   useEffect(() => {
//     if (values.iv_type) {
//       values.iv_level = '';
//       values.iv_role = '';
//       values.iv_circle = '';
//       values.iv_office_code = '';
//       setCircleCode(0)
//       values.iv_division = '';
//       setDivisionCode(0)
//       values.iv_sub_division = '';
//       setsubDivisionCode(0)
//       values.iv_support_center = '';
//       setcenterCscId(0)
//       if (hierarchy == 1) {
//         values.iv_company = '';
//         setcompanycode('');
//       }
//     }
//   }, [values.iv_type])

//   const [showPassword, setShowPassword] = React.useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
//   const handleClickShowPassword = () => setShowPassword((prev) => !prev);
//   const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   useEffect(() => {
//     const callCFCLevels = async () => {
//       setViewBackdrop(true)
//       let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
//       if (cfcLevelsList) {
//         if (hierarchy != 1) {
//           cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
//         }
//         setCFCLevelList(cfcLevelsList)
//       }
//       setViewBackdrop(false);
//     }
//     callCFCLevels()
//   }, [])

//   return (
//     <>
//       <Grid container className='form-box' sx={{ marginLeft: '30px', marginRight: '30px' }}>
//         <Grid item lg={12}>
//           <h3 className='page-title'>
//             Add New User
//           </h3>
//         </Grid>
//         <Grid item lg={12} sx={{ margin: '15px 0px' }}>
//           <Grid container sx={{ backgroundColor: 'white', borderRadius: '10px', border: '1px solid lightgrey', padding: '10px', minHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
//             <Grid item lg={12} sx={{ height: 'max-content' }}>
//               <Grid container sx={{ padding: '20px' }}>
//                 <Grid item lg={1.5} sx={{ border: '2px solid #006ad1', borderRadius: '10px', padding: '10px', maxHeight: '200px' }}>
//                   <img src={file ? URL.createObjectURL(file) : UserIconImage} alt='avatar' style={{ width: '100%' }} />
//                   <div style={{ width: '50px', height: '50px', borderRadius: '50px', backgroundColor: '#006ad1', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid white', zIndex: 1, position: 'absolute', marginLeft: '135px', marginTop: '-35px' }}>
//                     <label htmlFor='file'><DriveFolderUploadIcon sx={{ cursor: 'pointer', size: 'medium', color: 'white' }} /></label>
//                   </div>
//                   <input type="file" id="file" accept='image/*' onChange={(e) => setFile(e.target.files[0])} style={{ display: "none" }} />
//                 </Grid>
//                 <Grid item lg={10.5} sx={{ paddingLeft: '30px', }}>
//                   <Grid container >
//                     <Grid item lg={3} sx={{ padding: '10px' }}>
//                       <label>Employee Type</label>
//                       <Grid>
//                         {
//                           errors.iv_type && touched.iv_type ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_type}</p>
//                           ) : null
//                         }
//                       </Grid>
//                       <FormControl className='form-control' >
//                         <RadioGroup
//                           className='radio-group'
//                           row
//                           name="iv_type"
//                           defaultValue={values.iv_type}
//                           value={values.iv_type}
//                           onChange={handleChange}
//                         >
//                           {employeeType && employeeType.map((item) => {
//                             return <FormControlLabel
//                               value={item.roleTypeId}
//                               className='form-control-label'
//                               control={<Radio />}
//                               label={item.roleTypeName}
//                               labelPlacement="end"
//                             />
//                           })}
//                         </RadioGroup>
//                       </FormControl>
//                     </Grid>
//                      <Grid item lg={3} sx={{ padding: '10px' }}>
//                       <label>Status</label>
//                       <Grid>
//                         {
//                           errors.iv_status && touched.iv_status ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
//                           ) : null
//                         }
//                       </Grid>
//                       <FormControl >
//                         <RadioGroup
//                           row
//                           aria-labelledby="demo-row-radio-buttons-group-label"
//                           name="iv_status"
//                           id="iv_status"
//                           className='radio'
//                           value={values.iv_status}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                         >
//                           <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Active' />
//                           <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Inactive' />
//                         </RadioGroup>
//                       </FormControl>
//                     </Grid>
//                      <Grid item lg={3} sx={{ padding: '10px' }}>
//                       <label>Office Code</label>
//                       <TextField type='number' maxLength='5' readOnly onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} disabled sx={{
//                         backgroundColor: '#EEF1F7', width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                     </Grid>
//                     {
//                       values.iv_type == "1" &&
//                       <Grid item lg={3} sx={{ padding: '10px' }}>
//                         <label>Level</label>
//                         <Select
//                           fullWidth
//                           value={values.iv_level}
//                           onChange={handleLevelChange}
//                           sx={{ height: '45px', width: '100%' }}
//                           onBlur={handleBlur}
//                           name="iv_level"
//                           id="iv_level"
//                         >
//                           <MenuItem >Select Level</MenuItem>
//                           {
//                             cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
//                           }
//                         </Select>
//                         <Grid>
//                           {
//                             errors.iv_level && touched.iv_level ? (
//                               <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
//                             ) : null
//                           }
//                         </Grid>
//                       </Grid>
//                     } {
//                       values.iv_type == "2" &&
//                       <Grid item lg={3} sx={{ padding: '10px' }}>
//                         <label>Level</label>
//                         <Select
//                           fullWidth
//                           value={values.iv_level}
//                           onChange={handleLevelChange}
//                           sx={{ height: '45px', width: '100%' }}
//                           onBlur={handleBlur}
//                           name="iv_level"
//                           id="iv_level"
//                         >
//                           <MenuItem >Select Level</MenuItem>
//                           {
//                             technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
//                           }
//                         </Select>
//                         <Grid>
//                           {
//                             errors.iv_level && touched.iv_level ? (
//                               <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
//                             ) : null
//                           }
//                         </Grid>
//                       </Grid>
//                     }
                   
                   
//                     {
//                       values.iv_level > 1 ?
//                         <>
//                           <Grid item lg={3} sx={{ padding: '10px' }}>
//                             <label>Company</label>
//                             <Select
//                               fullWidth
//                               value={values.iv_company}
//                               disabled={parseInt(hierarchy) != 1}
//                               onChange={handleChangeCompany}
//                               sx={{ height: '45px' }}
//                               onBlur={handleBlur}
//                               name="iv_company"
//                               id="iv_company"
//                             >
//                               <MenuItem >Select Company</MenuItem>
//                               {
//                                 values.iv_level > 1 ?
//                                   companyList.map((item) =>
//                                     item.code > 1 ?
//                                       <MenuItem value={item.code}>{item.name}</MenuItem> : null) :
//                                   companyList.map((item) =>
//                                     <MenuItem value={item.code}>{item.name}</MenuItem>)
//                               }
//                             </Select>
//                             <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
//                               {errors.iv_company && touched.iv_company ? (errors.iv_company) : null}
//                             </Grid>
//                           </Grid>
//                         </> : null
//                     }
//                     {
//                       values.iv_level > 2 ?
//                         <Grid item lg={3} sx={{ padding: '10px' }}>
//                           <label>Circle</label>
//                           <Select
//                             fullWidth
//                             value={values.iv_circle}
//                             onChange={handleChangecircle}
//                             sx={{ height: '45px' }}
//                             onBlur={handleBlur}
//                             //displayEmpty
//                             name="iv_circle"
//                             id="iv_circle"
//                           >
//                             <MenuItem>Select Circle</MenuItem>
//                             {
//                               circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
//                             }
//                           </Select>
//                           <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
//                             {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
//                           </Grid>
//                         </Grid>
//                         : null
//                     }
//                     {
//                       values.iv_level > 3 ?
//                         <Grid item lg={3} sx={{ padding: '10px' }}>
//                           <label>Division</label>
//                           <Select
//                             fullWidth
//                             value={values.iv_division}
//                             onChange={handleChangedivision}
//                             sx={{ height: '45px' }}
//                             onBlur={handleBlur}
//                             //displayEmpty
//                             name="iv_division"
//                             id="iv_division"
//                           >
//                             <MenuItem>Select Division</MenuItem>
//                             {
//                               divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
//                             }
//                           </Select>
//                           <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
//                             {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
//                           </Grid>
//                         </Grid>
//                         : null
//                     }
//                     {
//                       values.iv_type == "1" ?
//                         <Grid lg={3} sx={{ padding: '10px' }}>
//                           <label>Customer Support Center</label>
//                           <Select
//                             fullWidth
//                             value={values.iv_support_center}
//                             onChange={handleChangecustomercenter}
//                             sx={{ height: '45px' }}
//                             onBlur={handleBlur}
//                             //displayEmpty
//                             name="iv_support_center"
//                             id="iv_support_center"
//                           >
//                             <MenuItem>Select CFC</MenuItem>
//                             {
//                               cfcsList.map((item) => {
//                                 if (item.cfcLevelId == values.iv_level) {
//                                   return (
//                                     <MenuItem value={item.cfcId}>{item.cfcName}</MenuItem>
//                                   )
//                                 }
//                               })
//                             }
//                           </Select>
//                           <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
//                             {errors.iv_support_center && touched.iv_support_center ? (errors.iv_support_center) : null}
//                           </Grid>
//                         </Grid>
//                         : null
//                     }
//                     {
//                       values.iv_level === 52 ?
//                         <Grid item lg={3} sx={{ padding: '10px' }}>
//                           <label>Sub Division</label>
//                           <Select
//                             fullWidth
//                             value={values.iv_sub_division}
//                             onChange={handleChangesubdivision}
//                             sx={{ height: '45px' }}
//                             onBlur={handleBlur}
//                             //displayEmpty
//                             name="iv_sub_division"
//                             id="iv_sub_division"
//                           >
//                             <MenuItem>Select Sub Division</MenuItem>
//                             {
//                               subdivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
//                             }
//                           </Select>
//                           <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
//                             {errors.iv_sub_division && touched.iv_sub_division ? (errors.iv_sub_division) : null}
//                           </Grid>
//                         </Grid>
//                         : null
//                     }
//                     <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px', padding: '5px' }}>
//                       <h4 style={{ color: '#006ad1' }}>
//                         User Role
//                       </h4>
//                     </Grid>
//                     <Grid item lg={12} sx={{ padding: '0px 10px' }}>
//                       {
//                         values.iv_level &&
//                         <>
//                           <Grid>
//                             {
//                               errors.iv_role && touched.iv_role ? (
//                                 <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_role}</p>
//                               ) : null
//                             }
//                           </Grid>
//                         </>

//                       }
//                       <FormControl>
//                         <RadioGroup
//                           row
//                           aria-labelledby="demo-row-radio-buttons-group-label"
//                           name="iv_role"
//                           id="iv_role"
//                           value={values.iv_role}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                         >
//                           <>
//                             <Grid sx={{ width: '100%' }}>
//                               {
//                                 allRoles && allRoles.map((item) => {
//                                   if (values.iv_level === item.level) {
//                                     return <FormControlLabel sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey', marginBottom: '10px' }} value={item.id} control={<Radio />} label={item.name} />
//                                   }
//                                 })
//                               }
//                             </Grid>
//                           </>
//                         </RadioGroup>
//                       </FormControl>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//             <Grid item lg={12} sx={{ height: 'max-content' }}>
//               <Grid container spacing={1}>
//                 <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px 30px', padding: '5px' }}>
//                   <h4 style={{ color: '#006ad1' }}>
//                     User Information
//                   </h4>
//                 </Grid>
//                 <Grid item lg={12}>
//                   <Grid container sx={{ padding: '0px 10px', height: '20vh' }}>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Full Name</label>
//                       <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_full_name" value={values.iv_full_name} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                       <Grid>
//                         {
//                           errors.iv_full_name && touched.iv_full_name ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_full_name}</p>
//                           ) : null
//                         }
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Username</label>
//                       <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_user_name" value={values.iv_user_name} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />

//                       {
//                         errors.iv_user_name && touched.iv_user_name ? (
//                           <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_user_name}</p>
//                         ) : null
//                       }

//                     </Grid>
//                     {/* <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Pin code</label>
//                       <TextField type='text' autoComplete='off' maxLength='4' onChange={handleChange} name="iv_pin_code" value={values.iv_pin_code} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                       <Grid>
//                         {
//                           errors.iv_pin_code && touched.iv_pin_code ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_pin_code}</p>
//                           ) : null
//                         }
//                       </Grid>
//                     </Grid> */}
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Email Address</label>
//                       <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_email" value={values.iv_email} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                       <Grid>
//                         {
//                           errors.iv_email && touched.iv_email ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_email}</p>
//                           ) : null
//                         }
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Phone No.</label>
//                       <TextField type='text' maxLength='11' autoComplete='off' onChange={handleChange} inputProps={{ maxLength: 11 }} name="iv_phone_no" value={values.iv_phone_no} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                       <Grid>
//                         {
//                           errors.iv_phone_no && touched.iv_phone_no ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_phone_no}</p>
//                           ) : null
//                         }
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>CNIC No.</label>
//                       <TextField type='text' maxLength="13" autoComplete='off' onChange={handleChange} name="iv_cnic" inputProps={{ maxLength: 13 }} value={values.iv_cnic} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }} />
//                       <Grid>
//                         {
//                           errors.iv_cnic && touched.iv_cnic ? (
//                             <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_cnic}</p>
//                           ) : null
//                         }
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Password</label>
//                       <TextField maxLength='16' type={showPassword ? 'text' : 'password'} autoComplete='off' onChange={handleChange} name="iv_password" value={values.iv_password} onBlur={handleBlur} sx={{
//                         width: '100%', '.MuiInputBase-input': {
//                           height: '1vh',
//                         },
//                       }}
//                         InputProps={{
//                           endAdornment: (
//                             (
//                               <InputAdornment position="end">
//                                 <IconButton
//                                   aria-label="toggle password visibility"
//                                   onClick={handleClickShowPassword}
//                                   onMouseDown={handleMouseDownPassword}
//                                   edge="end">

//                                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                                 </IconButton>
//                               </InputAdornment>
//                             )
//                           ),
//                         }}
//                       />
//                       <Grid>
//                         {errors.iv_password && touched.iv_password ? (
//                           <p style={{ color: '#f73232', fontSize: '1rem' }}>
//                             Password should:
//                             <ul>
//                               <li>have length between 8 to 16 characters.</li>
//                               <li>contain at least 1 lower case letter.</li>
//                               <li>contain at least 1 upper case letter.</li>
//                               <li>contain at least 1 number.</li>
//                               <li>contain at least 1 special character.</li>
//                             </ul>
//                           </p>
//                         ) : null}
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={3} sx={{ padding: '0px 10px' }}>
//                       <label>Password Confirmation</label>
//                       <TextField
//                         maxLength="16"
//                         type={showConfirmPassword ? 'text' : 'password'}
//                         autoComplete="off"
//                         onChange={handleChange}
//                         name="iv_confirm_password"
//                         value={values.iv_confirm_password}
//                         onBlur={handleBlur}
//                         sx={{
//                           width: '100%',
//                           '.MuiInputBase-input': {
//                             height: '1vh',
//                           },
//                         }}
//                         InputProps={{
//                           endAdornment: (
//                             (
//                               <InputAdornment position="end">
//                                 <IconButton
//                                   aria-label="toggle confirm password visibility"
//                                   onClick={handleClickShowConfirmPassword}
//                                   onMouseDown={handleMouseDownPassword}
//                                   edge="end"
//                                 >
//                                   {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                                 </IconButton>
//                               </InputAdornment>
//                             )
//                           ),
//                         }}
//                       />
//                       <Grid>
//                         {errors.iv_confirm_password && touched.iv_confirm_password ? (
//                           <p style={{ color: '#f73232', fontSize: '1rem' }}>
//                             {errors.iv_confirm_password}
//                           </p>
//                         ) : null}
//                       </Grid>
//                     </Grid>
//                     <Grid item lg={12} sx={{ margin: '0px 20px 0px 10px' }}>
//                       {
//                         error &&
//                         <Error
//                           error={error}
//                           onClose={() => errorCloses()}
//                           backgroundColor="#FFC0CB"
//                           textColor="#bb0303"
//                           iconColor="#bb0303"
//                         />
//                       }
//                     </Grid>
//                   </Grid>

//                   <Grid container sx={{ minHeight: '17.5vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>

//                     <Grid item lg={12} sx={{ padding: '0px 10px', textAlign: 'right' }}>
//                       <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
//                         Submit
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>


//       {/* Backdrop */}
//       < Backdrop
//         sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
//         open={viewBackdrop}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop >
//     </>
//   )
// }

// export default UserCreateForm

